module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-properties-86b3efe3997d97befde0f797acdc0bfd.svg";